import PropTypes from 'prop-types';
import React from 'react';

import overrideStyle from 'lib/overrideStyle';
import styles from 'presentation/components/styles/EndMessage.css';

export default function EndMessage(props) {
  const endMessagePropTypes = {
    message: PropTypes.string,
  };
  PropTypes.checkPropTypes(endMessagePropTypes, props, 'prop', 'EndMessage');

  return (
    <EndMessageDiv className={styles.endMessage_container} data-aid="gladlyChatEndMessage">
      <div className={styles.endMessage}>{props.message}</div>
    </EndMessageDiv>
  );
}

const EndMessageDiv = overrideStyle('div')`
  font-family: ${p => p.theme.fontLibrary.primary};
`;
